import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import * as moment from 'moment';
import { DateRangeType, FilterFieldValue } from './../covance-filter.models';
import { CovanceFilterBaseTypeComponent } from './covance-filter-base-type.component';
import { CovanceFilterDateRangeType } from './covance-filter-date-range-type';
import { Subscription } from 'rxjs';

interface RangeKind {
    key: DateRangeType;
    value: string;
}

@Component({
    selector: 'covance-filter-date-range-type',
    template: require('./covance-filter-date-range-type.component.html'),
    styles: [require('./covance-filter-date-range-type.component.scss')]
})
export class CovanceFilterDateRangeTypeComponent
    extends CovanceFilterBaseTypeComponent<CovanceFilterDateRangeType>
    implements AfterViewInit, OnDestroy {

    @Output()
    public valueChange = new EventEmitter<FilterFieldValue>();

    public isShowToSelector: boolean;

    public isShowFromSelector: boolean;

    public rangeKinds: RangeKind[] = [
        { key: 'dateRange', value: 'Range' },
        { key: 'today', value: 'Today' },
        { key: 'monthToDate', value: 'Month To Date' },
        { key: 'yearToDate', value: 'Year to Date' }
    ];

    public get selectedRangeKind(): RangeKind {
        if (this.fieldVal && this.fieldVal.value) {
            return this.rangeKinds.find(k => k.key === this.fieldVal.value.rangeType);
        }
        return this.rangeKinds[0];
    }

    public get isDateRangeKindSelected(): boolean {
        return this.selectedRangeKind != null && this.selectedRangeKind.key === 'dateRange';
    }

    private subscription: Subscription;

    constructor(protected filterDateRangeType: CovanceFilterDateRangeType, private ref: ChangeDetectorRef) {
        super(filterDateRangeType);
        this.subscription = filterDateRangeType.changeDetector.subscribe(_ => setTimeout(() => ref.markForCheck(), 0));
    }

    public onRangeKindChange(selectedRangeKinds: RangeKind[]) {
        this.fieldVal.value.rangeType = selectedRangeKinds[0].key;
        switch (this.selectedRangeKind.key) {
            case 'dateRange':
                this.onDateBeginChange(null);
                this.onDateEndChange(null);
                break;
            case 'today':
            case 'monthToDate':
            case 'yearToDate':
                this.onDateRangeChange();
                break;
        }
    }

    public onDateRangeChange() {
        this.filterType.setQueryParamValue(this.fieldVal);
        this.filterType.onFieldChange(this.fieldVal);
        this.valueChange.emit(this.fieldVal);
    }

    public onShowToSelector(isShowToSelector: boolean) {
        this.isShowToSelector = isShowToSelector;
    }

    public onShowFromSelector(isShowFromSelector: boolean) {
        this.isShowFromSelector = isShowFromSelector;
    }

    public onDateBeginChange($event: moment.Moment) {
        if (this.fieldVal.value) {
            this.fieldVal.value.dateBegin = this.filterType.formatDateTime($event);
        }
        //an ugly fix of incorect data picker renderring when after being cleared they do not catch data from the url
        setTimeout(
            () => {
                this.filterType.setQueryParamValue(this.fieldVal);
                this.filterType.onFieldChange(this.fieldVal);
                this.valueChange.emit(this.fieldVal);
            },
            0);
    }

    public onDateEndChange($event: moment.Moment) {
        if (this.fieldVal.value) {
            this.fieldVal.value.dateEnd = this.filterType.formatDateTime($event);
        }
        setTimeout(
            () => {
                this.filterType.setQueryParamValue(this.fieldVal);
                this.filterType.onFieldChange(this.fieldVal);
                this.valueChange.emit(this.fieldVal);
            },
            0);
    }

    public ngAfterViewInit(): void {
        //https://github.com/angular/angular/issues/10816#issuecomment-307638674
        setTimeout(() => this.ref.markForCheck(), 0);
    }

    public ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    public isInvalidDateRange() {
        if (!this.fieldVal.value || !this.fieldVal.value) {
            return false;
        }

        const dateBegin = moment(this.fieldVal.value.dateBegin);
        const dateEnd = moment(this.fieldVal.value.dateEnd);

        if (!dateBegin.isValid || !dateEnd.isValid) {
            false;
        }

        return dateBegin.isAfter(dateEnd);
    }
}
